import ReactGA from "react-ga4";

const MEASUREMENT_ID = import.meta.env.VITE_GA_MEASUREMENT_ID as
  | string
  | undefined;

let initialized = false;

/** Initialise GA4 once. No-op when the measurement ID is not configured. */
export const initGA = (): void => {
  if (initialized || !MEASUREMENT_ID) return;
  ReactGA.initialize(MEASUREMENT_ID);
  initialized = true;
};

export const trackPageView = (path: string, title?: string): void => {
  if (!initialized) return;
  ReactGA.send({ hitType: "pageview", page: path, title });
};

export const trackEvent = (
  category: string,
  action: string,
  label?: string,
  value?: number
): void => {
  if (!initialized) return;
  ReactGA.event({ category, action, label, value });
};
